import React, { PureComponent } from 'react';
import { string, bool } from 'prop-types';
import { injectIntl } from 'react-intl';
import { Fade } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { SimpleText } from 'util/IntlMessages';
import styles from './styles.module.scss';

class Progress extends PureComponent {
  static propTypes = {
    textId: string,
    positionRelative: bool,
  };

  static defaultProps = {
    textId: 'labels.loading',
  };

  render() {
    return (
      <div className={this.props.positionRelative ? styles.containerRelative : styles.container}>
        <div>
          <Fade in className={styles.fade} unmountOnExit>
            <CircularProgress className={styles.loader} />
          </Fade>
        </div>
        <p>
          <SimpleText id={this.props.textId} />
        </p>
      </div>
    );
  }
}

export default injectIntl(Progress);
